export var BookingFeeStatus;
(function (BookingFeeStatus) {
    /** There is no eCommerce order associated with the booking. */
    BookingFeeStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    /** The fee is informational only; the customer doesn't have to pay it. For example, it shows how much the customer would owe if they canceled the booking now. */
    BookingFeeStatus["PREVIEW"] = "PREVIEW";
    /** The booking fee hasn't been added to the eCommerce order yet. */
    BookingFeeStatus["NOT_YET_APPLIED_TO_ORDER"] = "NOT_YET_APPLIED_TO_ORDER";
    /** The booking fee has been added to the eCommerce order. The customer may not have paid it yet. */
    BookingFeeStatus["APPLIED_TO_ORDER"] = "APPLIED_TO_ORDER";
})(BookingFeeStatus || (BookingFeeStatus = {}));
/** The domain event that triggered the booking fee calculation. */
export var Trigger;
(function (Trigger) {
    /** There is no information about what triggered the creation of the booking fee. */
    Trigger["UNKNOWN_TRIGGER"] = "UNKNOWN_TRIGGER";
    /** The booking fee was created because the customer didn't show up to the booking or canceled after the expiration of the last cancellation window. */
    Trigger["NOT_ATTENDED"] = "NOT_ATTENDED";
    /** The booking fee was created because the customer canceled the booking before the expiration of the last cancellation window. */
    Trigger["BOOKING_CANCELED"] = "BOOKING_CANCELED";
})(Trigger || (Trigger = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map